import React from 'react';
import { Typography, Box } from '@mui/material';
import { Grid } from '@mui/material';
import { useDevice } from 'components/DeviceContext.js';

const PalavraDoPresidente = () => {
    const { isMobile } = useDevice();
    return (
        <Grid style={{ minHeight: '64vh', bgcolor: '#f5f5f5', justifyContent: 'center', display: 'flex' }}>
            <Box sx={{ padding: '2rem', borderRadius: '8px', width: isMobile ? '100%' : '70%' }}>
                <Typography variant="h4" component="h1" gutterBottom style={{ fontSize: isMobile ? '26px' : '' }}>
                    Palavra do Presidente
                </Typography>
                <Typography style={{ fontSize: isMobile ? '14px' : '' }}>
                    <Typography variant="body1" paragraph>
                        Prefeitos e prefeitas,
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Nos dias 2 e 3 de julho estaremos mobilizados em duas ocasiões em Brasília pela aprovação das
                        pautas prioritárias dos Municípios. A sua presença é fundamental para que o avanço dessas
                        demandas ocorra antes do início do recesso do Congresso Nacional. Iremos tratar com os
                        parlamentares pleitos como as medidas emergenciais e estruturantes que possibilitem o
                        restabelecimento das localidades afetadas pelas enchentes no Rio Grande do Sul e a
                        desoneração permanente da folha de pagamento.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Outro tema que será reforçado na mobilização é a urgência de um ⁠⁠refinanciamento das
                        dívidas previdenciárias e um⁠ ⁠⁠novo modelo de pagamento para os precatórios. Além disso,
                        outro assunto que vem sendo proposto pela CNM é a possibilidade de inclusão dos gastos com
                        pessoal das Organizações Sociais nos limites de gasto de pessoal, que causará extrapolação do
                        estabelecido na Lei de Responsabilidade Fiscal, com rejeição de contas, multas e inelegibilidade
                        de prefeitos. Também está em pauta o aumento em 1,5% do FPM.
                    </Typography>
                    <Typography variant="body1" paragraph>
                        Todas as demandas são essenciais para minimizar o cenário de dificuldades vivenciadas pelos
                        Municípios e auxiliar no encerramento de mandato. A mobilização será dividida em dois
                        momentos, sendo o primeiro no dia 2, pela manhã, com os gestores do Rio Grande do Sul. No
                        mesmo dia, na parte da tarde, o debate será pelo avanço das pautas nacionais, seguindo no dia
                        3.
                    </Typography>


                </Typography>
            </Box>
        </Grid>
    );
};

export default PalavraDoPresidente;
